import Vue from 'vue';
import VueI18n from 'vue-i18n';

import Constants from '../constants';

import enData from './message/en';
import jaData from './message/ja';



Vue.use(VueI18n);
const messages = {
    en: enData,
    ja: jaData,
}

function getLocale () {
    let targetLanguage = sessionStorage.getItem(Constants.LOCALE.SESSION_STORAGE_KEY);
    if (targetLanguage) {
        return targetLanguage;
    }

    let locale = navigator.language;
    if (!locale) { targetLanguage = Constants.LOCALE.EN; }
    else if (locale.match(/^en/)) { targetLanguage = Constants.LOCALE.EN; }  // 英語
    else if (locale.match(/^ja/)) { targetLanguage = Constants.LOCALE.JA; }  // 日本語
    else { targetLanguage = Constants.LOCALE.EN; }

    sessionStorage.setItem(Constants.LOCALE.SESSION_STORAGE_KEY, targetLanguage);
    return targetLanguage;
}
  
const i18n = new VueI18n({
    locale: getLocale(),
    messages,
});

export default i18n;
